import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3611abc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-invite-sender" }
const _hoisted_2 = { class: "user-invite-sender-tag-row stretch-row stretch-row-sm" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "hidden-xs" }
const _hoisted_5 = { class: "visible-xs-inline-block" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_7 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_8 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_9 = {
  key: 3,
  style: {"margin-top":"10px"},
  class: "panel panel-default invite-status-panel"
}
const _hoisted_10 = { class: "panel-body" }
const _hoisted_11 = { class: "invite-status-row-text" }
const _hoisted_12 = {
  key: 0,
  class: "invite-status label label-success"
}
const _hoisted_13 = {
  key: 1,
  class: "invite-status label label-warning"
}
const _hoisted_14 = { class: "invite-status-row-text" }

import { computed, ref, watch } from "vue";
import axios from "axios";
import VueTagsInput from "@sipec/vue3-tags-input";
import UserTag from "../user-tag";
import { EmailRegEx } from "./useInviteControlBase";


export default /*#__PURE__*/_defineComponent({
  __name: 'user-invite-sender',
  props: {
    userTags: { default: () => [] as UserTag[] },
    sendUrl: {},
    showExamples: { type: Boolean, default: true }
  },
  emits: ["send-started"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const tag = ref("");

const selectedUserTags = ref<UserTag[]>([]);

const sendError = ref(false);
const nameError = ref<string | null>(null);
const sending = ref(false);

function isEmail(email: string): boolean {
  return EmailRegEx.test(email ? email.trim() : email);
}

const hasAddressBook = computed(() => props.userTags.some((t) => !!t.id));

const sentTagValues = ref<UserTag[] | null>(null);

function markAsSent(sentTag: UserTag): void {
  sentTag.inviteSent = true;
  if (!sentTagValues.value!.some((t) => (t.id || t.text) === (sentTag.id || sentTag.text))) {
    sentTagValues.value!.push(sentTag);
  }
}

// Initialize sentTagValues based on props.userTags
function initializeSentTagValues() {
  if (!sentTagValues.value) {
    sentTagValues.value = [];
    props.userTags.filter((t) => t.inviteSent && t.text).forEach((t) => markAsSent(t));
  }
}

// Call the initialization function when component is created
initializeSentTagValues();

// Watch for changes in userTags and update sentTagValues accordingly
watch(
  () => props.userTags,
  (newTags) => {
    sentTagValues.value = [];
    newTags.filter((t) => t.inviteSent && t.text).forEach((t) => markAsSent(t));
  },
  { immediate: true },
);

const sentTags = computed(() => {
  return sentTagValues.value ?? [];
});

const exampleTags = computed(() => {
  const examples: string[] = [];
  for (let i = sentTags.value.length + 1; i <= 8; i++) {
    examples.push(`Invite person ${i}`);
  }
  return examples;
});

function isValidTag(userTag: UserTag): boolean {
  return !!userTag.id || isEmail(userTag.text);
}

const validation = [
  {
    classes: "tag-is-invalid",
    rule: (userTag: any): boolean => !isValidTag(userTag),
  },
];

function autocompleteItems(): UserTag[] {
  if ((tag.value || "").length === 0) {
    return props.userTags;
  }

  return props.userTags.filter(
    (i) =>
      (i.text || "").toLowerCase().indexOf((tag.value || "").toLowerCase()) !== -1 ||
      (i.email || "").toLowerCase().indexOf((tag.value || "").toLowerCase()) !== -1,
  );
}

function performSend(): void {
  if (sending.value) {
    return;
  }

  const tagsToSend: UserTag[] = [];

  selectedUserTags.value.forEach((sut) => {
    sut.text = sut.text ? sut.text.trim() : sut.text;
    sut.email = sut.email ? sut.email.trim() : sut.email;

    if (isValidTag(sut)) {
      tagsToSend.push(sut);
    } else {
      nameError.value = sut.text;
    }
  });

  if (tagsToSend.length === 0) {
    return;
  }

  sending.value = true;
  emit("send-started");

  axios
    .post(
      props.sendUrl,
      tagsToSend.map((t) => t.id || t.text),
    )
    .then((e) => {
      sending.value = false;
      sendError.value = false;
      tagsToSend.forEach((acceptedTag) => {
        markAsSent(acceptedTag);
      });

      selectedUserTags.value = selectedUserTags.value.filter((ut) => !ut.inviteSent); // Clear selectedUserTags
    })
    .catch((e) => {
      sending.value = false;
      sendError.value = true;
    });
}

function send(): void {
  window.setTimeout(() => performSend(), 1); // The reason for this timeout is the way tag creation works.
  // If we didn't have this timeout, if the last tag was still in "text" form, it wouldn't be sent.
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_unref(VueTagsInput), {
          class: "form-control input-lg user-invite-sender-input",
          modelValue: tag.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tag).value = $event)),
          placeholder: 
            hasAddressBook.value ? 'Enter names or email addresses...' : 'Enter email addresses'
          ,
          maxlength: 128,
          "max-tags": 40,
          validation: validation,
          tags: selectedUserTags.value,
          "autocomplete-items": autocompleteItems(),
          onTagsChanged: _cache[1] || (_cache[1] = (newTags) => (selectedUserTags.value = newTags)),
          "add-on-key": isEmail(tag.value) ? [13, 9, ':', ';', ' ', ','] : [13, 9, ':', ';'],
          "autocomplete-min-length": 0,
          "data-test": "invite-sender"
        }, null, 8, ["modelValue", "placeholder", "tags", "autocomplete-items", "add-on-key"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary btn-lg send-invites-button",
          disabled: sending.value,
          onClick: send,
          "data-test": "send-invites-button",
          type: "button"
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(sending.value ? "Sending..." : "Send Invites"), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(sending.value ? "..." : "Send"), 1)
        ], 8, _hoisted_3)
      ])
    ]),
    (sendError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, " There was a problem sending the invites. Please check your internet connection and try again. "))
      : _createCommentVNode("", true),
    (nameError.value && selectedUserTags.value.length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Sorry, we don't have an email address for " + _toDisplayString(nameError.value) + ". ", 1))
      : _createCommentVNode("", true),
    (selectedUserTags.value.length >= 40)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Can't send more than 40 invites at once. "))
      : _createCommentVNode("", true),
    (sentTags.value.length > 0 || _ctx.showExamples)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentTags.value, (sentTag) => {
              return (_openBlock(), _createElementBlock("p", {
                key: sentTag.id || sentTag.text,
                class: "invite-status-row stretch-row"
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(sentTag.text), 1),
                _createElementVNode("span", null, [
                  (sentTag.inviteDone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Completed"))
                    : _createCommentVNode("", true),
                  (!sentTag.inviteDone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Sent"))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            (_ctx.showExamples)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(exampleTags.value, (exampleText) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: exampleText,
                    class: "invite-status-row stretch-row example-invite-row"
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(exampleText), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})